import React, { useEffect } from "react";
import { startOfYear, format } from "date-fns";
import ScoreItem, { ScoreItemSkeleton } from "./ScoreItem";
import useCommonStore from "../../../../stores/common";
import useMerchantStore, {
  fetchChargebackScoreboard,
} from "../../../../stores/merchant";
import style from "./ScoreCard.module.scss";

function ScoreCard() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const dateRange = useCommonStore((state) => state.dateRange);
  const chargebackScoreboard = useMerchantStore(
    (state) => state.chargebackScoreboard,
  );
  const chargebackScoreboardLoading = useMerchantStore(
    (state) => state.chargebackScoreboardLoading,
  );

  useEffect(() => {
    const abortController = new AbortController();

    if (activeApp) {
      fetchChargebackScoreboard(
        activeApp?.power_app_submission?.mid,
        dateRange.startDate ?? format(startOfYear(new Date()), "yyyy-MM-dd"),
        dateRange.endDate ?? format(new Date(), "yyyy-MM-dd"),
        abortController,
      );
    }

    return () => {
      abortController.abort();
    };
  }, [activeApp, dateRange]);

  return (
    <div
      className={`${style.cb_score_card} ${expandDetails ? style.expanded : ""}`}
    >
      <div className={style.header}>
        <h5>CB Scorecard</h5>
      </div>

      {chargebackScoreboardLoading && (
        <div className={style.score_list}>
          {Array.from({ length: 4 }).map((_, index) => (
            <ScoreItemSkeleton key={index} />
          ))}
        </div>
      )}

      {!chargebackScoreboardLoading && chargebackScoreboard !== null && (
        <div className={style.score_list}>
          <ScoreItem
            title="New"
            amount={chargebackScoreboard.new_amount}
            chargebacks={chargebackScoreboard.new}
            totalChargebacks={chargebackScoreboard.total}
            color="#4C70EF"
          />

          <ScoreItem
            title="Pending"
            amount={chargebackScoreboard.pending_amount}
            chargebacks={chargebackScoreboard.pending}
            totalChargebacks={chargebackScoreboard.total}
            color="#254FE2"
          />

          <ScoreItem
            title="Won"
            amount={chargebackScoreboard.won_amount}
            chargebacks={chargebackScoreboard.won}
            totalChargebacks={chargebackScoreboard.total}
            color="#37B450"
          />

          <ScoreItem
            title="Loss"
            amount={chargebackScoreboard.loss_amount}
            chargebacks={chargebackScoreboard.loss}
            totalChargebacks={chargebackScoreboard.total}
            color="#E03B24"
          />
        </div>
      )}
    </div>
  );
}

export default ScoreCard;
